import { render } from "./ColumnWrapper.vue?vue&type=template&id=3d6b49bb"
import script from "./ColumnWrapper.vue?vue&type=script&lang=js"
export * from "./ColumnWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__